import script from "./SupervisionS.vue?vue&type=script&setup=true&lang=js"
export * from "./SupervisionS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__